import React from 'react';

const ORIGINAL_PRICE = 49.90;

const formatBRL = (value) => Number(value).toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

const OrderSummary = ({ certificatePrice, includesResume = true, className = '' }) => {
  const savings = Math.max(0, ORIGINAL_PRICE - Number(certificatePrice));

  return (
    <section className={`order-summary ${className}`.trim()} aria-labelledby="order-summary-title">
      <h3 id="order-summary-title">Resumo do pedido</h3>
      <div className="order-summary-line">
        <span>{includesResume ? 'Kit Profissional: Certificado + Currículo' : 'Certificado digital'}</span>
        <strong>{formatBRL(certificatePrice)}</strong>
      </div>
      <div className="order-summary-line order-summary-total">
        <span>Total</span>
        <span className="order-summary-promotional-price">
          <span className="order-summary-original-price">
            De <s>R$ 49,90</s> por
          </span>
          <strong>{formatBRL(certificatePrice)}</strong>
          <small>Economize {formatBRL(savings)}</small>
        </span>
      </div>
      <p>
        {includesResume
          ? 'O Certificado digital e o Currículo Profissional serão liberados após a aprovação do pagamento.'
          : 'O Certificado digital será liberado após a aprovação do pagamento. Seu acesso vitalício ao Currículo Profissional continua disponível.'}
      </p>
    </section>
  );
};

export default OrderSummary;
